<app-add-loose-article-to-offer [data]="data"></app-add-loose-article-to-offer>
